import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { routerOutletStyle } from '@shared/configs/router-outlet-style.config';

@Component({
  styles: routerOutletStyle,
  selector: 'app-module-router',
  template: '<router-outlet />',
  imports: [RouterModule],
})
export class ModuleRouterComponent { }
